module.exports = __webpack_public_path__ + "img/platform9.4d73be73.png";